export default __webpack_public_path__ + "static/media/content5.b6e39e31.jpg";